import { AspectRatio, Box, Center, Flex, HStack, Spacer, Text } from '@chakra-ui/react';
import { Price } from 'hooks';
import { ICurrency, IMedia } from 'hooks/types';
import { AiOutlineHeart, AiOutlineStar } from 'react-icons/ai';
import { API_URL } from 'services/api';
import { ImageSlider } from '../ImageSlider';

type DestinationBoxProps = {
  data: {
    image: string;
    name?: string;
    isFavorite: boolean;
    destinationName: string;
    duration: string;
    hotelName: string;
    state?: string;
    starRating?: number;
    description: string;
    price: Price;
    type: string;
    hotelMedia?: IMedia[];
    currency?: ICurrency;
  };
};

const DestinationBox = ({ data }: DestinationBoxProps) => {
  return (
    <>
      <Box >
        <Box position='relative'>
          <AspectRatio ratio={1} maxW={'100%'}>
          <ImageSlider images={data.hotelMedia?.map(media => ({url: `${API_URL}/hotelimages/${media.mediaUrlNo}`})) || []} />
          </AspectRatio>
          <Center backgroundColor='#FBFBFB' position='absolute' top={4} right={4} padding={3} borderRadius={'full'}>
            <AiOutlineHeart color='#6F6F6F' size={18} />
          </Center>
        </Box>
        <Box>
          <Flex alignItems='center'>
            <Text color='primary.black' fontSize='4xl' fontWeight={700}>
              {data.state}
            </Text>
            <Spacer />
            <Text fontSize='md' color='primary.grey' fontWeight={500}>
              {data.duration}
            </Text>
          </Flex>
          <Flex>
            <Text fontSize='lg' color='primary.black' fontWeight={600}>
              {data.name}
            </Text>
            <Spacer />
            <HStack spacing={2}>
              <Text color='primary.grey' fontSize='md' fontWeight={400}>
                {data.starRating}
              </Text>
              <AiOutlineStar color='primary.grey' />
            </HStack>
          </Flex>
          <Flex>
            <Text color='primary.grey' fontSize='md' fontWeight={400}>
              {data.description}
            </Text>
          </Flex>
          <Flex alignItems='center'>
            <HStack spacing={3}>
              <Text color='blue.5' fontSize='4xl' fontWeight={700}>
              {data.currency?.symbol}
              </Text>
              <Text color='primary.grey' fontSize='lg' fontWeight={400}>
                
              </Text>
            </HStack>
          </Flex>
        </Box>
      </Box>
    </>
  );
};

export { DestinationBox };
